// /shop/how-to-measure — where to put the tape on each kind of door. One rule, six doors,
// a photo or a drawing for each. Hugh is photographing the real doors (17 Sep 2026): drop
// each one in at public/images/shop/measure/<key>.jpg and set `img` here; until then the
// page draws the door. CommonJS so the static build can require it.
const measureGuide = {
  h1: 'How to measure the backset',
  metaTitle: 'How to Measure a Door Backset — Aluminium, Timber and Sliding Doors | Shore Doors',
  metaDescription:
    'The backset is the distance from the door edge to the centre of the keyhole or spindle. Where to put the tape on aluminium narrow-stile doors, timber mortice doors, round-bore deadbolts, ranch sliders and blank doors, with the sizes each lock comes in.',
  rule: 'Tape on the edge of the door, read across to the centre of the keyhole or handle spindle. That number is the backset.',
  doors: [
    {
      key: 'aluminium-hinged',
      title: 'Aluminium hinged door',
      tape: 'Door edge to the centre of the keyhole (or the lever spindle) on the lock that is there now.',
      sizes: 'Usually 30, 35, 40 or 45 mm on a narrow stile.',
      tip: 'Measure the lock, not the handle, and not to the glass. If the door has a lip or rebate on the edge, measure from the face the lock faceplate sits on.',
      diagram: 'hinged',
      img: '/images/work/narrow-mortice-aluminium-door.jpeg',
      imgAlt: 'Narrow mortice lock in an aluminium door stile',
    },
    {
      key: 'timber-mortice',
      title: 'Timber door with a mortice lock',
      tape: 'Door edge to the centre of the keyhole.',
      sizes: 'Usually 60 mm; 70 mm on thick, wide doors.',
      tip: 'A mortice lock has a rectangular faceplate in the door edge. Open the door and hook the tape on the edge, over the faceplate.',
      diagram: 'hinged',
      img: '/images/work/mortice-thumbturn-wooden-door.jpeg',
      imgAlt: 'Mortice lock with thumbturn on a timber door',
    },
    {
      key: 'round-bore',
      title: 'Timber door with a round-bore deadbolt or lever',
      tape: 'Door edge to the centre of the round hole — the middle of the knob, thumbturn or keypad.',
      sizes: '60 or 70 mm. The new latch adjusts to either, so this one only needs to be close.',
      tip: 'If the old lock is off, the hole through the door is about 54 mm across; measure to its centre.',
      diagram: 'bore',
      img: null,
      imgAlt: 'Round-bore deadbolt on a timber door',
    },
    {
      key: 'sliding',
      title: 'Sliding door or ranch slider',
      tape: 'Door edge to the centre of the keyhole on the hook lock — not the pull handle beside it.',
      sizes: '28 or 35 mm.',
      tip: 'The hook drops into a box in the frame; if the lock is out, that box tells you the size too.',
      diagram: 'sliding',
      img: '/images/work/electronic-sliding-door-hook-lock.jpeg',
      imgAlt: 'Electronic hook lock on a sliding door',
    },
    {
      key: 'multipoint',
      title: 'Lift-to-lock (multipoint) door',
      tape: 'Door edge to the centre of the cylinder, the round keyhole under the handle.',
      sizes: 'Usually 30 to 45 mm in aluminium.',
      tip: 'These doors lock top and bottom as well; the lock body sets what can replace it, so with installation we check the lock body before we book.',
      diagram: 'hinged',
      img: null,
      imgAlt: 'Multipoint lock faceplate in an aluminium door edge',
    },
    {
      key: 'blank',
      title: 'Blank door, no lock yet',
      tape: 'Aluminium: the width of the flat stile beside the glass. Timber: nothing to measure.',
      sizes: 'Aluminium: about half the flat stile — a 70 mm stile takes 35 mm, a 90 mm stile 45 mm. Timber: 60 mm is standard.',
      tip: 'The whole lock body has to sit on the flat part, never over the glass bead or a frame joint. Ordering with installation? We cut it to the right size on the day.',
      diagram: 'blank',
      img: null,
      imgAlt: 'Blank aluminium door stile beside the glass',
    },
  ],
  mistakes: [
    { title: 'Measuring to the handle', text: 'The lever or pull can sit anywhere. The backset is to the keyhole or spindle.' },
    { title: 'Measuring the faceplate', text: 'The width of the plate in the door edge is not the backset.' },
    { title: 'Measuring from the glass', text: 'Start at the edge of the door, not the glass line or the frame.' },
    { title: 'Measuring with the door shut', text: 'Open it. The edge is where the tape hooks on.' },
  ],
};

module.exports = { measureGuide };
